import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";

const CHARACTER_BASE = "https://content.code-pro.app/character";
/**
 * characterCode:
 * skin_body_face_eyes_eyebrows_mouth_nose_ears_bg_hair
 *
 * Example:
 * 1_0_3_0_1_2_0_0_1_2
 */
export default function CharacterImage({
    characterCode,
    editable = false,
    onEdit,
    className = "",
}) {
    if (!characterCode) return null;

    const parts = characterCode.split("_");

    if (parts.length < 9) return null;

    const [
        skin,
        bodyIndex,
        faceIndex,
        eyesIndex,
        eyebrowsIndex,
        mouthIndex,
        noseIndex,
        earsIndex,
        bgIndex,
        hairIndex = -1,
    ] = parts.map(Number);

    const image = (name) => `${CHARACTER_BASE}/${name}.png`;

/*
 * Same logic as Android findSkinIndexedDrawable()
 */
const skinIndexed = (prefix, skin, index) => {
    const skinNumber = skin + 1;
    const variantNumber = index + 1;

    // body_skin1_01
    return image(
        `${prefix}${skinNumber}_${String(variantNumber).padStart(2, "0")}`
    );
};

const background = image(`character_bg_${bgIndex}`);

const body = skinIndexed("body_skin", skin, bodyIndex);
const face = skinIndexed("face_skin", skin, faceIndex);
const ears = skinIndexed("ears_skin", skin, earsIndex);

const eyes = image(`eyes${String(eyesIndex + 1).padStart(2, "0")}`);

const eyebrows = image(
    `eyebrows_${eyebrowsIndex + 1}`
);

const mouth = image(`mouth_${mouthIndex + 1}`);

const nose = image(`nose_${noseIndex + 1}`);

const hairBack =
    hairIndex >= 0
        ? image(`hair${hairIndex + 1}_back`)
        : null;

const hairFront =
    hairIndex >= 0
        ? image(`hair${hairIndex + 1}_front`)
        : null;

return (
    <div
        className={`relative w-48 h-48 rounded-md overflow-hidden ${className}`}
        style={{
            backgroundImage: `url(${background})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
        }}
    >
        {/* BACK HAIR */}
        {hairBack && (
            <img
                src={hairBack}
                alt=""
                className="absolute left-1/2 top-1/2 w-[200px] -translate-x-1/2 -translate-y-1/2"
            />
        )}

        {/* BODY */}
        <img
            src={body}
            alt=""
            className="absolute left-1/2 bottom-0 h-[300px] -translate-x-1/2 translate-y-[8px]"
        />

        {/* FACE */}
        <img
            src={face}
            alt=""
            className="absolute left-1/2 bottom-0 h-[200px] -translate-x-1/2 mb-4"
        />

        {/* EARS */}
        <img
            src={ears}
            alt=""
            className="absolute left-1/2 bottom-0 h-[140px] -translate-x-1/2"
        />

        {/* NOSE */}
        <img
            src={nose}
            alt=""
            className="absolute left-1/2 top-1/2 w-[18px] -translate-x-1/2 translate-y-[3px] z-10"
        />

        {/* EYES */}
        <img
            src={eyes}
            alt=""
            className="absolute left-1/2 top-1/2 w-[51px] -translate-x-1/2 -translate-y-[20px] z-10"
        />

        {/* EYEBROWS */}
        <img
            src={eyebrows}
            alt=""
            className="absolute left-1/2 top-1/2 h-[8px] -translate-x-1/2 -translate-y-[35px] z-10"
        />

        {/* MOUTH */}
        <img
            src={mouth}
            alt=""
            className="absolute left-1/2 top-1/2 h-[16px] -translate-x-1/2 translate-y-[28px] z-10"
        />

        {/* FRONT HAIR */}
        {hairFront && (
            <img
                src={hairFront}
                alt=""
                className="absolute left-1/2 bottom-0 w-[272px] -translate-x-1/2 z-10"
            />
        )}

        {/* EDIT BUTTON */}
        {editable && (
            <button
                type="button"
                onClick={onEdit}
                className="
                        absolute
                        left-3
                        top-3
                        z-20
                        w-12
                        h-12
                        rounded-full
                        flex
                        items-center
                        justify-center
                        bg-gray-700
                        border-b-4
                        border-gray-900
                        hover:bg-gray-900
                        active:border-b-0
                        cursor-pointer
                        transition
                    "
            >
                <FontAwesomeIcon
                    icon={faPencil}
                    size="md"
                    className="text-white"
                />
            </button>
        )}
    </div>
);
}